// extracted by mini-css-extract-plugin
module.exports = {"justification":"ReplacementsModal_justification__17_p9","name":"ReplacementsModal_name__z8hG_"};